import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ahaApi from "../../app/services/aha-api";

const initialState = {
  value: [],
  loading: false,
};

export const updateTimedDraws = createAsyncThunk(
  "timedDraws/updateTimedDraws",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.updateOrder(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const updateTimedDrawsSlice = createSlice({
  name: "updateTimedDraws",
  initialState,
  reducers: {
    clearUpdateTimedDrawsResponse(state, action) {
      state.value = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateTimedDraws.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTimedDraws.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(updateTimedDraws.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const updateTimedDrawsList = (state) => state.updateTimedDraws.value;
export const updateTimedDrawsLoader = (state) => state.updateTimedDraws.loading;
export const { clearUpdateTimedDrawsResponse } = updateTimedDrawsSlice.actions;

export default updateTimedDrawsSlice.reducer;
